import { CustomerGenderType } from "@/types/customer/customer.type";
import { GENDER } from "@/enums/gender.enum";

export class CustomerGenderModule {
  gender?: any;
  id?: GENDER;
  text?: string = "";

  constructor(gender) {
    this.gender = gender;
  }

  toJson(): string {
    return this.gender?.id;
  }

  toData(): CustomerGenderType {
    return {
      id: this.gender || GENDER.UNSPECIFIED,
      text: this.getGenderText(),
    };
  }

  getGenderText(): string {
    let text = "";
    switch (this.gender) {
      case GENDER.UNSPECIFIED:
        text = "Unspecified";
        break;
      case GENDER.MALE:
        text = "Male";
        break;
      case GENDER.FEMALE:
        text = "Female";
        break;
    }

    return text;
  }
}
